import React, { useEffect, useState, useRef } from 'react';
interface AnimatedMetricProps {
  value: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
}
export function AnimatedMetric({
  value,
  suffix = '',
  prefix = '',
  duration = 2000
}: AnimatedMetricProps) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !isVisible) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.5
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [isVisible]);
  useEffect(() => {
    if (!isVisible) return;
    const startTime = Date.now();
    const endTime = startTime + duration;
    const updateCount = () => {
      const now = Date.now();
      const progress = Math.min((now - startTime) / duration, 1);
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(easeOutQuart * value));
      if (now < endTime) {
        requestAnimationFrame(updateCount);
      } else {
        setCount(value);
      }
    };
    requestAnimationFrame(updateCount);
  }, [isVisible, value, duration]);
  return <div ref={ref} className="font-bold text-navy" data-id="element-1085">
      {prefix}
      {count}
      {suffix}
    </div>;
}